function insertSpacesInCamelCase(value: string): string {
  return value
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
    .trim();
}

export function formatAssociationType(value: string | null | undefined): string {
  if (value == null || value === '' || value === '-') {
    return '-';
  }
  const normalized = value.toLowerCase().replace(/[\s_\-]+/g, '');
  if (normalized === 'therapeutic') {
    return 'Therapeutic Target';
  }
  if (normalized === 'upregulation') return 'Upregulation';
  if (normalized === 'downregulation') return 'Downregulation';
  if (normalized === 'accumulationandaggregation') return 'Accumulation and Aggregation';
  if (normalized === 'activity') return 'Activity';
  if (normalized === 'qtl') return 'QTL';
  if (value.includes(' ') || value.includes('-')) {
    return value;
  }
  if (/^[A-Z0-9]+$/.test(value)) {
    return value;
  }
  return insertSpacesInCamelCase(value);
}
